import { proxy } from 'valtio'
let fileStore = proxy({
    props:{}
})

export {
    fileStore
}

